<template>
  <quick-card title="General Class Settings">
    <template v-slot:card-content>hello</template>
  </quick-card>
</template>

<script>
import QuickCard from "../Quickcard";
export default {
  name: "class-gen",
  components: {
    "quick-card": QuickCard
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/settings/classGen.vue